import React from "react";
import slide1 from '../Assets/Images/slide1.jpg'
import slide2 from '../Assets/Images/slide2.jpg'
import Slider from "react-slick";
import { Link } from "react-router-dom";
function HomeSlider() {
  var settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 1000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0
  };
  return (
    <div class="slider">
    <div className="slider-container">
      <Slider {...settings}>
        <div>
        <img src={slide2} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
        <div>
        <img src={slide1} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
        <div>
        <img src={slide2} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
        <div>
        <img src={slide1} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
        <div>
        <img src={slide2} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
        <div>
        <img src={slide1} className="img-fluid" alt="Sacred Heart Convent School, Jagraon" />
        </div>
      </Slider>
    </div>
    </div>
  );
}

export default HomeSlider;